import React, { useEffect } from 'react';

const BookingWidget = () => {
  useEffect(() => {
    // Redirect to Uplisting booking page
    window.location.replace('/properties');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mx-auto mb-4"></div>
        <p className="text-slate-600">Redirecting to booking...</p>
      </div>
    </div>
  );
};

export default BookingWidget;
